export class Translation {
  constructor(public readonly translation: string) {}
  get(): string {
    return this.translation;
  }
}
